export default {
    getMyGoods(state){
        return state.goodsBuy;
    },    
}